import React from "react";
import { EarIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { Countdown } from "../Countdown";
import { images } from "../../data/content";
export function HeroSection() {
  return <header className="relative bg-cream px-5 pt-8 pb-14 sm:pt-12 sm:pb-20" data-id="element-195" data-mp="219bbtkd4hzav">
      <div className="mx-auto max-w-5xl text-center" data-id="element-196" data-mp="1x9ak4y10jrlv">
        <div className="flex items-center justify-center gap-2.5" data-id="element-197" data-mp="1x8hiucktpub4">
          <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-navy text-white" data-id="element-198" data-mp="1sapshmztug91">
            <EarIcon className="h-5 w-5" aria-hidden="true" data-id="element-199" data-mp="1ni66q2qzket5" />
          </span>
          <span className="font-serif text-lg sm:text-xl font-bold text-navy" data-id="element-200" data-mp="1ij3c7c8mtqzf">Otoplasty Clinical Pathway System™</span>
        </div>

        <h1 className="mt-7 font-serif text-[38px] leading-[1.06] sm:text-6xl lg:text-7xl font-extrabold text-ink text-balance" data-id="element-201" data-mp="1dmcyuwo7p9hp">
          Review the Complete Otoplasty Learning Pathway in{" "}
          <em className="italic text-brand" data-id="element-202" data-mp="14klsrqprf0nb">15 Minutes</em>
        </h1>

        <p className="mx-auto mt-5 max-w-2xl text-lg sm:text-xl leading-relaxed text-ink/75" data-id="element-203" data-mp="31nvz3fwfv6ll">
          A structured educational system designed to help plastic surgeons organize their study of otoplasty — from
          anatomical assessment and preoperative planning concepts through procedural overview and postoperative review.
        </p>
        <p className="mx-auto mt-3 max-w-2xl text-base sm:text-lg text-ink/80" data-id="element-204" data-mp="2wpb2rrkb572f">
          Includes <strong className="text-ink" data-id="element-205" data-mp="3kff2hnudkmo5">6 premium volumes</strong>, <strong className="text-ink" data-id="element-206" data-mp="3pe8gdhdkqfou">5 professional bonuses</strong>,
          visual learning tools, educational case exercises, and structured review checklists.
        </p>

        <p className="mt-8 font-serif text-xl sm:text-2xl font-bold text-navy" data-id="element-207" data-mp="3gd0iv1ivtivt">
          The 6 Volumes + 5 Bonuses Inside Otoplasty Clinical Pathway System™
        </p>
        <img src={images.mockup} alt="Otoplasty Clinical Pathway System — 6 volumes, worksheets and 5 bonuses" className="mx-auto mt-4 w-full max-w-3xl drop-shadow-xl" loading="eager" data-id="element-208" data-mp="1zxh5s8tofyb0" />

        <div className="mt-8" data-id="element-209" data-mp="5itv9p0406hq">
          <CtaButton id="first-cta" label="I want the Otoplasty Clinical Pathway System™" pulse data-id="element-210" data-mp="5jlfy4s64jt8" />
          <p className="mx-auto mt-4 max-w-xl text-sm sm:text-base text-ink/70" data-id="element-211" data-mp="qsbli0m3dho">
            Instant digital access · One-time payment of <strong className="text-ink" data-id="element-212" data-mp="3sve1tmi85hbq">$27 USD</strong> · Lifetime access · 7-day guarantee
          </p>
        </div>

        <div className="mt-8" data-id="element-213" data-mp="3nu6utpnwom64">
          <Countdown data-id="element-214" data-mp="3iwx7cfk2ukkx" />
          <p className="mt-5 inline-block rounded-lg bg-alert px-3 py-1.5 text-xs sm:text-sm font-extrabold uppercase tracking-wider text-white" data-id="element-215" data-mp="3iwotolg4rb8o">
            Limited launch price
          </p>
          <p className="mt-2 text-sm text-ink/65" data-id="element-216" data-mp="39xtmp759hx4b">The promotional price is available for a limited time.</p>
        </div>
      </div>
    </header>;
}